import { Link } from 'react-router-dom'

function Privacy() {
  return (
    <div style={{
      maxWidth: '900px',
      margin: '40px auto',
      padding: '28px'
    }}>
      <div style={{
        background: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 8px 30px rgba(11,110,246,0.06)',
        padding: '28px'
      }}>
        <nav style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '18px' }}>
          <a href="#introduction" style={{ fontSize: '0.875rem', color: '#0b6ef6', textDecoration: 'none' }}>Introduction</a>
          <a href="#data-collected" style={{ fontSize: '0.875rem', color: '#0b6ef6', textDecoration: 'none' }}>Data Collected</a>
          <a href="#use" style={{ fontSize: '0.875rem', color: '#0b6ef6', textDecoration: 'none' }}>How We Use Data</a>
          <a href="#sharing" style={{ fontSize: '0.875rem', color: '#0b6ef6', textDecoration: 'none' }}>Data Sharing</a>
          <a href="#security" style={{ fontSize: '0.875rem', color: '#0b6ef6', textDecoration: 'none' }}>Security</a>
          <a href="#rights" style={{ fontSize: '0.875rem', color: '#0b6ef6', textDecoration: 'none' }}>Your Rights</a>
          <a href="#cookies" style={{ fontSize: '0.875rem', color: '#0b6ef6', textDecoration: 'none' }}>Cookies & Tracking</a>
          <a href="#contact" style={{ fontSize: '0.875rem', color: '#0b6ef6', textDecoration: 'none' }}>Contact</a>
        </nav>

        <header style={{ maxWidth: '820px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '1.5rem', margin: '0 0 6px' }}>Privacy Policy</h1>
          <p style={{ color: '#6b7280', margin: '0 0 6px' }}>
            This Privacy Policy explains how Wurlo UK ("we", "us", "our") collects, uses, and protects personal information when you use wurlo.org (the "Site") and our tutor-facing diagnostics tools.
          </p>
          <p style={{ color: '#6b7280', margin: '0 0 18px' }}>
            Our tools are designed for tutors and students aged 13 and over. We do not knowingly collect data from or provide services to children under 13, and tutors must not add under-13 students.
          </p>
          <p style={{ fontSize: '0.9rem', color: '#6b7280' }}>Last updated: December 9, 2025</p>
        </header>

        <section id="introduction" style={{ margin: '18px 0' }}>
          <h2 style={{ fontSize: '1.05rem', marginBottom: '8px' }}>1. Introduction</h2>
          <p>
            Wurlo UK is committed to protecting your privacy and complying with applicable UK and EU data protection laws, including the UK GDPR and Data Protection Act 2018. This Privacy Policy applies to tutors and other adult users of our Site and services.
          </p>
          <p style={{ marginTop: '8px' }}>
            Our diagnostics and reporting tools are intended for use with students who are 13 years of age or older. Tutors must not add students under the age of 13, and we do not knowingly collect data from or provide services to children under 13.
          </p>
        </section>

        <section id="data-collected" style={{ margin: '18px 0' }}>
          <h2 style={{ fontSize: '1.05rem', marginBottom: '8px' }}>2. Data We Collect</h2>
          <p>In the context of our tutor-facing diagnostics platform, we may collect the following types of data:</p>
          <ul style={{ margin: '8px 0 8px 20px' }}>
            <li><strong>Tutor account data</strong> – such as your name, email address, authentication details, and communication preferences.</li>
            <li><strong>Student identifiers (13+ only)</strong> – such as a first name or nickname, and contact details (e.g., email or phone) used solely to deliver diagnostic quizzes and reports.</li>
            <li><strong>Diagnostic responses and results</strong> – answers to quiz questions, performance metrics, and generated reports used to provide learning diagnostics.</li>
            <li><strong>Usage data</strong> – including pages visited, time spent, actions taken in the app (e.g., creating students, sending quizzes), and similar interaction data.</li>
            <li><strong>Device and browser information</strong> – such as IP address, operating system, browser type, and general location (e.g., city/region).</li>
            <li><strong>Payment and billing details</strong> – if you purchase a product or subscription, processed securely via third-party payment providers.</li>
          </ul>
          <p style={{ marginTop: '8px' }}>
            We design our flows to screen out under-13 students and immediately block services where age requirements are not met.
          </p>
        </section>

        <section id="use" style={{ margin: '18px 0' }}>
          <h2 style={{ fontSize: '1.05rem', marginBottom: '8px' }}>3. How We Use Your Data</h2>
          <p>We use personal data primarily to operate a secure, tutor-facing diagnostics platform. In particular, we use data to:</p>
          <ul style={{ margin: '8px 0 8px 20px' }}>
            <li>Provide, personalise, and maintain our diagnostics services for tutors and eligible students (13+).</li>
            <li>Generate adaptive quizzes, diagnostic reports, and insights to support learning and tutoring.</li>
            <li>Communicate with you about your account, product changes, security notices, and important updates.</li>
            <li>Send product news or marketing communications where you have opted in (you can opt out at any time).</li>
            <li>Monitor, maintain, and improve the security, performance, and usability of our Site and services.</li>
            <li>Comply with legal obligations and enforce our Terms of Service.</li>
          </ul>
          <p style={{ marginTop: '8px' }}>
            We may also use aggregated, de-identified data from diagnostics to improve our question bank, AI models, and overall product (our "AI flywheel"). When we do this, data is anonymised or pseudonymised so that it no longer identifies individual students or tutors.
          </p>
        </section>

        <section id="sharing" style={{ margin: '18px 0' }}>
          <h2 style={{ fontSize: '1.05rem', marginBottom: '8px' }}>4. Data Sharing</h2>
          <p>
            We do <strong>not</strong> sell personal data, and we do not share student or tutor data with third parties for their own marketing purposes.
          </p>
          <p style={{ marginTop: '8px' }}>We may share information with:</p>
          <ul style={{ margin: '8px 0 8px 20px' }}>
            <li>Carefully selected service providers who perform services on our behalf (e.g., cloud hosting, email delivery, analytics, payment processing).</li>
            <li>Legal authorities or regulators where required by law, court order, or to protect our legal rights, users, or the public.</li>
          </ul>
          <p style={{ marginTop: '8px' }}>
            When we use third-party providers, they are required to protect your data, follow our instructions, and use the data only to provide services to us.
          </p>
        </section>

        <section id="security" style={{ margin: '18px 0' }}>
          <h2 style={{ fontSize: '1.05rem', marginBottom: '8px' }}>5. Data Security</h2>
          <p>We implement appropriate technical and organizational measures to protect personal data from unauthorized access, loss, or alteration. However, no system can be completely secure, and we cannot guarantee absolute security.</p>
        </section>

        <section id="rights" style={{ margin: '18px 0' }}>
          <h2 style={{ fontSize: '1.05rem', marginBottom: '8px' }}>6. Your Rights & Access / Deletion Requests</h2>
          <p>You have the following rights under UK GDPR:</p>
          <ul style={{ margin: '8px 0 8px 20px' }}>
            <li>Access and obtain a copy of your personal data.</li>
            <li>Request correction of inaccurate or incomplete data.</li>
            <li>Request deletion of your data (subject to legal obligations).</li>
            <li>Withdraw consent for data processing where applicable.</li>
            <li>Object to processing for marketing or legitimate interest purposes.</li>
            <li>Request data portability.</li>
          </ul>
          <p style={{ marginTop: '8px' }}>
            <strong>Tutors</strong>: If you would like to access, export, or delete your account data or data about students you manage, please contact us from the email address associated with your account. We may ask you to confirm certain details to verify your identity.
          </p>
          <p style={{ marginTop: '8px' }}>
            <strong>Parents / guardians and students (13+)</strong>: If you believe your data is being processed through a tutor&apos;s account and you would like to access or delete it, please ask the tutor to contact us, or contact us directly with as much detail as possible so we can locate the relevant records.
          </p>
          <p style={{ marginTop: '8px' }}>
            If we discover that data relating to a child under 13 has been provided to us, we will delete it as soon as reasonably practicable.
          </p>
          <p style={{ marginTop: '8px' }}>
            To exercise any of these rights, please contact us at <a href="mailto:contact@wurlo.org" style={{ color: '#0b6ef6', textDecoration: 'underline' }}>contact@wurlo.org</a>.
          </p>
        </section>

        <section id="cookies" style={{ margin: '18px 0' }}>
          <h2 style={{ fontSize: '1.05rem', marginBottom: '8px' }}>7. Cookies & Tracking</h2>
          <p>We use cookies and similar tracking technologies to enhance your experience, analyse site usage, and deliver relevant content. You can manage or disable cookies via your browser settings. Essential cookies are required to use our Site and cannot be disabled.</p>
        </section>

        <section id="contact" style={{ margin: '18px 0' }}>
          <h2 style={{ fontSize: '1.05rem', marginBottom: '8px' }}>8. Contact</h2>
          <p>If you have questions about this Privacy Policy or our data practices, please contact us at <a href="mailto:contact@wurlo.org" style={{ color: '#0b6ef6', textDecoration: 'underline' }}>contact@wurlo.org</a>.</p>
        </section>

        <footer style={{ borderTop: '1px solid #eef2f7', paddingTop: '14px', color: '#6b7280', fontSize: '0.9rem' }}>
          <p style={{ fontSize: '0.9rem' }}>This Privacy Policy is the entire privacy notice for Wurlo UK. We may update it from time to time; updates will be posted on this page with a new "Last Updated" date.</p>
          <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #eef2f7' }}>
            <nav style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
              <Link to="/" style={{ color: '#0b6ef6', textDecoration: 'underline' }}>← Back to Home</Link>
              <span style={{ color: '#6b7280' }}>•</span>
              <Link to="/terms" style={{ color: '#0b6ef6', textDecoration: 'underline' }}>Terms & Conditions</Link>
              <span style={{ color: '#6b7280' }}>•</span>
              <a href="mailto:contact@wurlo.org" style={{ color: '#0b6ef6', textDecoration: 'underline' }}>Contact</a>
            </nav>
          </div>
          <p style={{ fontSize: '0.9rem', marginTop: '12px' }}>© Wurlo UK. All rights reserved.</p>
        </footer>
      </div>
    </div>
  )
}

export default Privacy
